import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
// eslint-disable-next-line
import Styles from "./styles/AppStyles.module.scss";
import PageNotFound from "./components/screens/generic-screens/PageNotFound";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Dashboard from "./components/screens/dashboard/Dashboard";
import RequireUnauth from "./components/wrappers/RequireUnauth";
import RequireAuth from "./components/wrappers/RequireAuth";
import ErrorScreen from "./components/screens/generic-screens/ErrorScreen";
import ProtectedRoute from "./components/wrappers/ProtectedRoute";
import { LoadScript } from "@react-google-maps/api";
import { MAP_KEYS } from "./configs/MAPConfig";
import LoginScreen from "./components/screens/login/LoginScreen";

function App() {
  return (
    <>
      <LoadScript googleMapsApiKey={MAP_KEYS.GOOGLE_MAP_KEY}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route
            path="/login"
            element={
              <RequireUnauth>
                <LoginScreen emailLogin />
              </RequireUnauth>
            }
          />
          {/* <Route
            path="/login-otp"
            element={
              <RequireUnauth>
                <LoginScreen />
              </RequireUnauth>
            }
          /> */}
          <Route
            path="/dashboard/*"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/error"
            element={<ProtectedRoute component={ErrorScreen} />}
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <ToastContainer />
      </LoadScript>
    </>
  );
}

export default App;
